import { PageTitle } from "../shared";
import { SystemStatusSection } from "./system-status-section";

export const SystemStatus = () => (
  <>
    <PageTitle title={"System Status"} />
    <SystemStatusSection hideTitle={true} />
  </>
)
